import {
  msalInstance,
  forgotPasswordRequest,
  loginRequest,
} from '../authConfig/authConfig';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';

export const b2cLogin = () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
    if (event.eventType === EventType.LOGIN_FAILURE) {
      // Check for forgot password error
      // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
      if (event.error?.message.includes('AADB2C90118')) {
        msalInstance.loginRedirect(forgotPasswordRequest);
      }
    }
  });
};

export const getCrmId = (msal: PublicClientApplication) => {
  return (
    (msal.getActiveAccount()?.idTokenClaims
      ?.extension_CrmContactId as string) || ''
  );
};

export const getIdProvider = (msal: PublicClientApplication) =>
  (msal.getActiveAccount()?.idTokenClaims?.idp as string) || '';

export const handleLoginSuccess = (
  event: EventMessage,
  idSetter: React.Dispatch<React.SetStateAction<string>>,
  setIdProvider: React.Dispatch<React.SetStateAction<string>>,
) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const payload = event.payload;

    const {
      extension_CrmContactId: crmId,
      idp: idProvider,
      // @ts-ignore
    } = payload?.account.idTokenClaims || {};
    /**
     * idp is undefined for WCC Dynamics account, "google.com" for Google account, "facebook.com" for Facebook account
     */
    setIdProvider(idProvider || '');
    idSetter(crmId || '');
  }
};

export const handleLoginPageEvent = (
  msal: PublicClientApplication,
  idSetter: React.Dispatch<React.SetStateAction<string>>,
  setIdProvider: React.Dispatch<React.SetStateAction<string>>,
) => {
  // Check if the user is already logged in and set CRM id
  if (msal.getAllAccounts().length > 0) {
    const id = getCrmId(msal);
    const idProvider = getIdProvider(msal);
    idSetter(id);
    setIdProvider(idProvider);
  } else {
    // If not logged in, add callback for login success event
    msal.addEventCallback((event) =>
      handleLoginSuccess(event, idSetter, setIdProvider),
    );
  }
};

export type LoginRequestConfig = {
  msal: PublicClientApplication;
  navigate: () => void;
};

export const handleLoginRequest = async (config: LoginRequestConfig) => {
  const { msal, navigate } = config;
  const LOGIN_ERROR_MESSAGE =
    'Your login request failed. Please refresh the page and try again';

  if (msal.getAllAccounts().length > 0) {
    navigate();
    return;
  }

  try {
    await msal.loginRedirect(loginRequest);
  } catch (error) {
    throw new Error(LOGIN_ERROR_MESSAGE);
  }
};
